import './Header.css';
import heart from '../../assets/graphics/toolbar/toolbar-star-n.png';
import backLanding from "../../assets/graphics/toolbar/toolbar-back-landing.png";
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isHeartRotated, setIsHeartRotated] = useState(false);
    const [historyStack, setHistoryStack] = useState([]); // Simulating history stack

    // Track the history of navigation
    useEffect(() => {
        setHistoryStack((prevStack) => [...prevStack, location.pathname]);
    }, [location.pathname]);

    const goBackTwoPages = () => {
        if (historyStack.length >= 2) {
            const twoPagesBack = historyStack[historyStack.length - 3];
            if (twoPagesBack && twoPagesBack.startsWith('/')) {
                navigate(twoPagesBack);
            } else {
                navigate('/dreams');
            }
        } else {
            navigate('/dreams');
        }
    };

    const handleBackClick = () => {
        if (location.pathname === '/dreams') {
            navigate("/");
        } else {
            navigate("/dreams");
        }
    };

    // Logic for the heart click (handling navigation to /about)
    const handleAboutClick = () => {
        if (location.pathname !== '/about') {
            setIsHeartRotated(true);
            navigate('/about');
        } else {
            const onePageBack = historyStack[historyStack.length - 2];
            if (onePageBack && onePageBack.startsWith('/')) {
                navigate(-1); // Go back one page
            } else {
                navigate('/dreams');
            }
        }
    };

    // Sync heart rotation state based on URL
    useEffect(() => {
        if (location.pathname === '/about') {
            setIsHeartRotated(true);
        } else {
            setIsHeartRotated(false);
        }
    }, [location.pathname]);

    return (
        <header className="header">
            <button className="back" onClick={handleBackClick}>
                <img src={backLanding} alt="Back" className="backButton" />
            </button>
            <div className="right-bar">
                <button className={`heart ${isHeartRotated ? 'rotated' : ''}`} onClick={handleAboutClick}>
                    <img src={heart} alt="about" className="heartButton" />
                </button>
            </div>
        </header>
    );
};

export default Header;
